import { UI, VStack } from '@genial/components';
import { BoxBorder, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { IconographyTypes } from '@genial/icons';
import React from 'react';

import { LateralBar } from '../../../../../../../../components/LateralBar';
import { TableContentItemCaptions } from '../../../../../../../../components/TableContent';
import { ProductCardItem, ProductCardItemProps } from '../ProductCardItem';

export interface ProductCardProps {
  productColor: ColorTypes.Option;
  title: string;
  subtitle?: string;
  captions?: IconographyTypes.Option[];
  infos: ProductCardItemProps[];
  BottomComponent: React.ReactNode;
  TopComponent?: React.ReactNode;
  zIndex?: number;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  infos,
  title,
  subtitle,
  captions,
  productColor,
  BottomComponent,
  TopComponent,
  zIndex,
}) => {
  const hasCaptions = !!captions?.length;

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} position="relative" zIndex={zIndex}>
      <LateralBar barColor={productColor} />
      <VStack p={Spacing['inset.sm']} space={Spacing['stack.xxxs']}>
        <VStack space={hasCaptions ? Spacing['stack.quarck'] : 0}>
          <UI.Text variant="semibold" fontSize={Typography['fontsize.lg']}>
            {title}
          </UI.Text>
          {hasCaptions && <TableContentItemCaptions icons={captions} />}
          {!!subtitle && (
            <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              {subtitle}
            </UI.Text>
          )}
        </VStack>
        {TopComponent}
        {infos.map((info, index) => (
          <React.Fragment key={index}>
            <ProductCardItem {...info} />
          </React.Fragment>
        ))}
        {BottomComponent}
      </VStack>
    </UI.Shadow>
  );
};
